import { dataMember, required, typedArray } from 'santee-dcts';
import { CategoryNaturalKey } from '../../documents';
import { EmailPreferenceLevelType } from './levels/email-preference-level-type';
import { Site } from '../../sites/site';
import { Protocol } from '../../admin/shared/protocol';

export class EmailPreferenceCategory {

    @dataMember()
    @required()
    public categoryId: CategoryNaturalKey;

    @dataMember()
    @required()
    public categoryName: string;
}

export class Email {
    @dataMember()
    @required()
    public sitelinkUserEmailId?: string;

    @dataMember()
    @required()
    public emailAddress: string;

    @dataMember()
    @required()
    public isDefault: boolean;

    public toString() {
        return this.description;
    }

    public get description() {
        return this.isDefault ? `${this.emailAddress} (default)` : this.emailAddress;
    }
}

export class EmailPreference {
    @dataMember()
    @required()
    public sitelinkEmailPrefId: string;

    @dataMember()
    @required()
    public sitelinkUserEmailId: string;

    @dataMember()
    @required()
    public categoryId: CategoryNaturalKey;

    @dataMember()
    @required()
    public levelIndicator: EmailPreferenceLevelType;

    @dataMember()
    @required()
    public prefValue: number;

    @dataMember()
    @required({ nullable: true })
    public siteId: number;

    @dataMember()
    @required({ nullable: true })
    public protocolId: number;
}

export class EmailPreferenceReadModel {
    @dataMember()
    @required()
    public email: Email;

    @dataMember()
    @required({ nullable: true })
    public site: Site;

    @dataMember()
    @required({ nullable: true })
    public protocol: Protocol;

    @dataMember()
    @required()
    @typedArray(EmailPreference)
    public emailPreferences: EmailPreference[];
}